export const currency_format = (digit: number) => '$' + digit.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

export const roundOffAmount = (amount: number) => Math.round(amount);